import { getNodeEnv, getPublicEnvValue } from './env';

export const CDN_URL = 'https://l0xlmyrl8323.edge.naverncp.com';

function isLocalDevHost() {
  return (
    window.location.hostname.includes('localhost') ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '0.0.0.0' ||
    window.location.port !== ''
  );
}

function isAdminPrefixedPath() {
  return window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');
}

export const BASE_URL = getNodeEnv() == 'production' || isLocalDevHost() || !isAdminPrefixedPath() ? '' : '/admin';

export const POPUP_BASE_URL = getPublicEnvValue('VITE_V1_API_URL') || 'https://checkbus.irontrain.co.kr';

export const V2_BASE_URL = getPublicEnvValue('VITE_V2_API_URL') || 'https://api.checkbus.co.kr';

// cookie
export const MODAL_MANUAL_HIDE_COOKIE_TODAY = 'hideManualModalToday';
export const MODAL_MANUAL_HIDE_COOKIE = 'hideManualModal';
export const MODAL_ACCOUNT_POPUP_TODAY = 'hideAccountModalPopupToday';

export const TEACHER_TYPES = ['T', 'ETC'];
export const TEACHER_EXCEPT_PATHS: { [key: string]: string[] } = {
  student: [],
  setup: ['/receipt', '/check'],
  cash: ['', '/charge', '/charge-detail', '/use-detail'],
  account: ['', '/check', '/manage', '/create', '/statistics', '/calculate', '/sms', 'download', '/toss-manager'],
};
export const PAIED_EXCEPT_PATHS = {
  setup: ['/product'],
};
export const FREE_EXCEPT_PATHS = {
  cash: ['', '/charge', '/charge-detail', '/use-detail'],
  account: ['/toss-manager'],
};
export const NOT_REGISTRAION_ACCOUNT = {
  account: ['/manage', '/create', '/statistics', '/calculate', '/sms', 'download', '/toss-manager'],
};

export const NOT_ACCOUNT = {
  account: ['', '/check', '/manage', '/create', '/statistics', '/calculate', '/sms', 'download', '/toss-manager'],
};

export const NOT_USE_TAB = -1;

export const PAYMENT_CANCEL_PRERIOD = 90;
export const ANALYSIS_AREA_MIN = 1000000;

export const LINK_BILLING_MOCK_IMG = CDN_URL + '/checkbus/assets/guide/payment_mock.png';
export const LINK_BILLING_METHOD_VIDEO_HYOSUNG =
  CDN_URL + '/checkbus/assets/guide/tosspayment_register_guide_v2_hyosung.mp4';
export const LINK_BILLING_METHOD_VIDEO = CDN_URL + '/checkbus/assets/guide/tosspayment_register_guide_v2.mp4';
export const LINK_BILLING_METHOD_PDF = CDN_URL + '/checkbus/assets/guide/tosspayment_register_guide.pdf';

export const LINK_PAY_METHOD_VIDEO = CDN_URL + '/checkbus/assets/guide/tosspayment_payment_manual.mp4';
export const LINK_ALL_METHOD_PDF = CDN_URL + '/checkbus/alim_complete_manual.pdf';
export const LINK_CHECKBUS_METHOD_PDF = CDN_URL + '/checkbus/checkbus_user_manual.pdf';
export const LINK_CHECKBUS_METHOD_VIDEO = 'https://www.youtube.com/watch?v=KAtYihcwW-0';

export enum TableTypeKeys {
  account_calculate_academy,
  account_calculate_user,
  account_check,
  account_manage_list,
  account_manage_create,
  account_statistics_period,
  account_statistics_daily,
  account_statistics_detail,
  attendance_covid_record,
  attendance_covid_unrecord,
  attendance_manager,
  attendance_status_record,
  attendance_status_unrecord,
  cash_charge,
  cash_used,
  setup_check,
  sms_detail,
  sms_send,
  sms_reservation,
  student_class,
  student_list,
  student_study,
  student_teacher,
  student_counsel,
  magazine_birthday,
}

export const UserTablQeuryColumn: Record<string, keyof typeof TableTypeKeys> = {
  calculate_list: 'account_calculate_academy',
  calculate_detail: 'account_calculate_user',
  account_check: 'account_check',
  account_manage_create: 'account_manage_create',
  account_manage_check: 'account_manage_list',
  account_statistics: 'account_statistics_period',
  account_statistics_daily: 'account_statistics_daily',
  account_analysis_month: 'account_statistics_detail',
  record_record: 'attendance_covid_record',
  record_unrecord: 'attendance_covid_unrecord',
  manager: 'attendance_manager',
  status_record: 'attendance_status_record',
  status_unrecord: 'attendance_status_unrecord',
  charge_detail: 'cash_charge',
  use_detail: 'cash_used',
  setup_check: 'setup_check',
  detail: 'sms_detail',
  send: 'sms_send',
  reservation: 'sms_reservation',
  class: 'student_class',
  student: 'student_list',
  study: 'student_study',
  teacher: 'student_teacher',
  counsel: 'student_counsel',
  birthday: 'magazine_birthday',
};

export const TableDefaultSortKey = {
  student_teacher: {
    sortKey: 'uclass',
    sortValue: 'asc',
  },
  student_class: { sortKey: 'rname', sortValue: 'asc' },
  student_list: { sortKey: 'rname', sortValue: 'asc' },
  student_study: { sortKey: 'reportdate', sortValue: 'desc' },
  student_counsel: { sortKey: 'postdate', sortValue: 'desc' },
  attendance_status_record: { sortKey: 'rname', sortValue: 'asc' },
  attendance_status_unrecord: { sortKey: 'rname', sortValue: 'asc' },
  attendance_covid_record: { sortKey: 'rname', sortValue: 'asc' },
  attendance_covid_unrecord: { sortKey: 'rname', sortValue: 'asc' },
  attendance_manager: { sortKey: 'start', sortValue: 'desc' },
  account_check: { sortKey: 'uname', sortValue: 'asc' }, // pretest값에 따라 default가 다르긴 함
  account_manage_list: { sortKey: '', sortValue: '' },
  account_manage_create: { sortKey: '', sortValue: '' },
  account_statistics_period: { sortKey: '', sortValue: '' },
  account_statistics_daily: { sortKey: 'amount', sortValue: 'desc' },
  account_statistics_detail: { sortKey: '', sortValue: '' },
  account_calculate_academy: { sortKey: '', sortValue: '' },
  account_calculate_user: { sortKey: 'complete_date_time', sortValue: 'asc' },
  sms_send: { sortKey: 'rname', sortValue: 'asc' },
  sms_detail: { sortKey: 'postdate', sortValue: 'desc' },
  sms_reservation: { sortKey: 'reserveddate', sortValue: 'asc' },
  setup_check: { sortKey: 'postdate', sortValue: 'desc' },
  cash_charge: { sortKey: 'chargeday', sortValue: 'desc' },
  cash_used: { sortKey: 'postdate', sortValue: 'desc' },
  magazine_birthday: { sortKey: 'ubirth', sortValue: 'desc' },
};

export const EventDates = ['2026-06-19 08:59:59', '2026-06-30 23:59:59'];
export const EventName = '상반기 결산 혜택'; // 헤더 버튼명
export const EventChargeName = '26년 상반기 결산 혜택'; //  출결캐쉬 신청명

export const HyosungDisabledDates = [
  { startDate: '2026-05-23 23:00:00', endDate: '2026-05-24 18:00:00', endTimeStr: '24일 오후 06시' },
  // { startDate: '2024-11-09 23:30:00', endDate: '2024-11-10 07:00:00', endTimeStr: '오전 07시' },
];

export const VirtualAccountDisabledDates = [
  { startDate: '2025-05-03 00:00:00', endDate: '2025-05-03 13:00:00', endTimeStr: '오전 00시' },
];

export const CLASS_REGISTRATION_TUTORIAL = {
  rname: {
    key: 't1',
    seq: 1,
    isOpen: true,
    placement: 'left',
    text: '선생님의 클래스 명을 기입해주세요.',
  },
  uname: {
    key: 't1',
    seq: 2,
    isOpen: false,
    placement: 'left',
    text: '선생님을 선택하세요. 나중에 추가할 수 있어요.',
  },
  rcheckday: {
    key: 't1',
    seq: 3,
    isOpen: false,
    placement: 'left',
    text: '해당 클래스의 출석 요일을 선택해주세요.',
  },
  add: {
    key: 't1',
    seq: 4,
    isOpen: false,
    placement: 'left',
    text: '모두 입력하셨으면 등록해주세요.',
  },
};

export const BILL_TEST_TUTORIAL = {
  content: {
    key: 'f_t4',
    seq: 1,
    isOpen: true,
    placement: 'right',
    text: '청구서 내용을 적어보세요.',
    className: 'f_t4',
    sx: { zIndex: 1301 },
  },
  cost: {
    key: 'f_t4',
    seq: 2,
    isOpen: false,
    placement: 'right',
    text: '청구서 금액을 적어보세요.',
    zIndex: 1301,
    className: 'f_t4',
    sx: { zIndex: 1301 },
  },
  payment_due_date: {
    key: 'f_t4',
    seq: 3,
    isOpen: false,
    placement: 'right',
    text: '청구서 기한을 선택하세요.',
    zIndex: 1301,
    className: 'f_t4',
    sx: { zIndex: 1301 },
  },
  test_send: {
    key: 'f_t4',
    seq: 4,
    isOpen: false,
    placement: 'right',
    text: '학원비 청구서를 받아보세요.',
    zIndex: 1301,
    className: 'f_t4',
    sx: { zIndex: 1301 },
  },
};

export const APP_TUTORIAL = {
  key: 't1',
  seq: 1,
  isOpen: true,
  placement: 'left' as FunnelTooltipProps['placement'],
  text: '신속 정확한 출석 체크를 시작해보세요.',
  sx: {
    marginLeft: '-18px !important',
  },
};

export const FUNNEL_TYPE_CLASS = 1;
export const FUNNEL_TYPE_STUDENT = 2;
export const FUNNEL_TYPE_APP = 3;
export const FUNNEL_TYPE_ACCOUNT = 4;
export const FUNNEL_TYPE_SMS = 5;
export const FUNNEL_TYPE_REGISTRATION = 6;

// * 매년 상반기 효성 결제 이벤트 관련 객체
export const HyosungEventDates = {
  startDate: '2026-05-19 00:00:00',
  endDate: '2026-05-23 22:59:59',
  width: String(864 * 0.8),
  height: String(864 * 0.8),
  img: CDN_URL + '/checkbus/assets/events/hyosung_service_disable.png',
  hiddenWeek: false,
};

// * 수납 index에서 보여줄 팝업 관련
export const NOTICE_INFO_ACCOUNTS = {
  startDate: '2026-06-25 00:00:00',
  endDate: '2026-08-16 23:59:59',
  width: String(864 * 0.64),
  height: String(864 * 0.64),
  img: CDN_URL + '/checkbus/notify/noti_toss_onboarding.gif',
  hiddenWeek: false,
};

// * 발신번호 설정 불가 flag
export const DISABLED_CHANGED_SMS_PHONE = false;
